export const getDefaultCloneName = (originalName, suffix = " - Clone", maxLength = 50) => {
  if (originalName.length + suffix.length <= maxLength) {
    return originalName + suffix;
  }
  
  // Truncate original name to fit within limit
  const truncatedLength = maxLength - suffix.length;
  return originalName.substring(0, truncatedLength) + suffix;
};